var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheck = function SvgIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.8 44.8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7ad535",
    d: "M21.3 0c3.9-.2 7.8.6 11.2 2.4 4 2 7.3 5.2 9.5 9.1 1.4 2.5 2.3 5.2 2.6 8 .7 5-.4 10.2-3 14.5-2.4 3.9-6 7.1-10.2 8.9-2.8 1.2-5.8 1.9-8.8 1.9-4.8.1-9.6-1.5-13.5-4.3-2.2-1.6-4-3.6-5.5-5.8C1.7 31.8.5 28.5.1 25.1c-.4-3.2-.1-6.5.9-9.6.9-2.9 2.5-5.7 4.6-8 2-2.3 4.6-4.2 7.4-5.5C15.6.9 18.4.2 21.3 0m-4.8 28.9c-2.3-2.5-4.5-5-6.8-7.5-.8.8-1.6 1.7-2.3 2.5 3 3.3 6.1 6.7 9.1 10 6.5-7.2 13-14.3 19.5-21.5-.7-.8-1.4-1.7-2.1-2.5-5.8 6.3-11.6 12.6-17.4 19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.5 28.9c5.8-6.3 11.6-12.7 17.4-19 .7.8 1.4 1.7 2.1 2.5-6.5 7.2-13 14.3-19.5 21.5-3-3.3-6.1-6.7-9.1-10 .8-.8 1.6-1.7 2.3-2.5 2.2 2.4 4.5 4.9 6.8 7.5"
  })));
};
export default SvgIconCheck;